import React from 'react';
import { Box, Grid, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../../../../../../styles/colors';
import {
  AssignmentQuestion,
  AssignmentQuestionAnswer
} from '../../../state/assignment-edit.types';
import { useAppSelector } from '../../../../../../../redux/hooks';
import { DeleteOutlined, Done, EditOutlined, ArrowRightAlt } from '@material-ui/icons';
import { QuestionFormatNumber } from '../../../../../../../enums/QuestionFormat';

const useStyles = makeStyles({
  root: {
    borderRadius: '4px',
    border: `1px solid ${colors.assignment.grey}`
  },
  padding: {
    padding: '1.2rem'
  },
  header: {
    backgroundColor: colors.assignment.grey,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  list: {
    listStyle: 'none'
  },
  round: {
    marginRight: '10px',
    borderRadius: '50%',
    width: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '20px',
    border: `1px solid ${colors.assignment.grey}`
  },
  textLine: {
    width: '100%',
    textAlign: 'left',
    borderBottom: `1px solid ${colors.assignment.grey}`,
    lineHeight: '0.1em',
    margin: '10px 0 20px'
  },
  text: {
    background: '#fff',
    padding: '0 10px',
    fontSize: '12px',
    marginLeft: '20px',
    color: `${colors.assignment.grey}`
  }
});
interface QuestionRendererProps {
  handleQuestionIndex(...args: any): any;
  question: AssignmentQuestion;
  isPassageQuestion?: boolean;
  isEditable?: boolean;
  setQuestionEditMode?: any;
  handleDeleteQuestion?: any;
  rootId?: string | number;
  showDelete?: boolean;
}
const QuestionRenderer = (props: QuestionRendererProps) => {
  const classes = useStyles();
  const {
    question,
    handleQuestionIndex,
    isPassageQuestion,
    rootId,
    setQuestionEditMode,
    handleDeleteQuestion,
    showDelete,
    isEditable
  } = props;
  const { answers, questionType } = question;
  const skills = useAppSelector(state => state.editAssignment.skills);
  let index = handleQuestionIndex(
    question.id,
    isPassageQuestion ? rootId : null
  );
  const skill = skills.find(skill => skill.id === question.skillId);
  return (
    <Grid container className={classes.root}>
      <Grid className={`${classes.padding} ${classes.header}`} item xs={12}>
        <span>
          Q{index} - {skill?.name}{' '}
          {questionType === 'Open-Ended' && 'Open Ended'}
        </span>
        <Box>
          {!rootId && isEditable && (
            <IconButton
              onClick={() => setQuestionEditMode(question.id, rootId)}
            >
              <EditOutlined />
            </IconButton>
          )}
          {showDelete && (
            <IconButton
              onClick={() => handleDeleteQuestion(question.id, rootId)}
            >
              <DeleteOutlined />
            </IconButton>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} className={classes.padding}>
        <span dangerouslySetInnerHTML={{ __html: question.question }} />
      </Grid>
      <Grid item xs={12} className={classes.padding}>
        <h2 className={classes.textLine}>
          <span className={classes.text}>answer choices</span>
        </h2>
        <ul className={classes.list}>
          {question.format === QuestionFormatNumber.Pair && answers.map(
            (answer:any) => {
              return (
                <li
                  style={{
                    margin: '10px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  key={typeof answer !== 'string' ? answer?.id : index}
                >
                  &nbsp;{answer.text} &nbsp; <ArrowRightAlt fontSize='large' /> &nbsp; {answer.pair}
                </li>
              );
            }
          )}

          {question.format !== QuestionFormatNumber.Pair && answers.map(
            (answer: AssignmentQuestionAnswer | string, index: number) => {
              let answerText = '';
              if (typeof answer === 'string') {
                answerText = answer;
              } else {
                answerText = answer.text;
              }
              return (
                <li
                  style={{
                    margin: '10px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  key={typeof answer !== 'string' ? answer?.id : index}
                >
                  <div className={classes.round}>
                    {question.format === QuestionFormatNumber.DragAndDrop || question.format === QuestionFormatNumber.Order ? (
                      <span>{index + 1}</span>
                    ) : (
                      typeof answer !== 'string' &&
                      answer?.isCorrect && (
                        <Done style={{ color: colors.green }} />
                      )
                    )}
                  </div>
                  &nbsp;{answerText}
                </li>
              );
            }
          )}
          {questionType === 'Open-Ended' && (
            <li
              style={{
                margin: '10px',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              User inputted answer
            </li>
          )}
        </ul>
      </Grid>
      {/*{question.feedbackIncorrect && (*/}
      {/*  <Grid item xs={12} className={classes.padding}>*/}
      {/*    <h2 className={classes.textLine}>*/}
      {/*      <span className={classes.text}>Feedback</span>*/}
      {/*    </h2>*/}
      {/*    <span>{question.feedbackIncorrect}</span>*/}
      {/*  </Grid>*/}
      {/*)}*/}
    </Grid>
  );
};

export default QuestionRenderer;
